const initialState = {
  enabled: false, // default to disabled - will be enabled by CUSTOM Message nodes when needed
};

export default function copilotWidget(state = initialState, action) {
  switch (action.type) {
    case 'OPEN_COPILOT_WIDGET':
      return { ...state, enabled: action.payload.enabled };
    default:
      return state;
  }
}
